import { Link } from 'react-router-dom'
import { useSiteContent } from '@/hooks/useSiteContent'
import { getIndianMobileError, isValidIndianMobile, phonePattern, submitInquiry } from '@/lib/inquiries'
import { FormEvent, useState } from 'react'

const RealEstatePage = () => {
  const { content } = useSiteContent()
  const [phoneError, setPhoneError] = useState('')
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle')
  const [formMessage, setFormMessage] = useState('')

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const form = event.currentTarget
    const formData = new FormData(form)
    const contactNumber = String(formData.get('contactNumber') || '')
    const currentPhoneError = getIndianMobileError(contactNumber)

    if (currentPhoneError || !isValidIndianMobile(contactNumber)) {
      setPhoneError(currentPhoneError || 'Enter a valid 10 digit Indian mobile number.')
      setFormStatus('idle')
      return
    }

    if (!form.checkValidity()) {
      form.reportValidity()
      return
    }

    setPhoneError('')
    setFormStatus('submitting')
    setFormMessage('')

    try {
      await submitInquiry('shelf_owner', {
        name: String(formData.get('name') || ''),
        realEstateType: String(formData.get('realEstateType') || ''),
        contactNumber,
        message: String(formData.get('message') || ''),
      })

      form.reset()
      setFormStatus('success')
      setFormMessage('Thanks. Your enquiry has been sent to Shelf Discovery.')
    } catch {
      setFormStatus('error')
      setFormMessage('We could not send this right now. Please email support@shelfdiscovery.in.')
    }
  }

  return (
    <main className="site-shell">
      <header className="site-nav">
        <Link to="/" className="brand-mark">{content.nav.brand}</Link>
        <nav aria-label="Primary navigation">
          <Link to="/real-estate" className="nav-cta">{content.nav.shelfOwnersCta}</Link>
          <Link to="/brands" className="nav-cta">{content.nav.brandsCta}</Link>
        </nav>
      </header>

      <section className="info-page">
        <div className="info-page__content">
          <p className="info-page__eyebrow">{content.realEstatePage.eyebrow}</p>
          <h1>{content.realEstatePage.title}</h1>
          <p>{content.realEstatePage.body}</p>
        </div>

        <form
          className="contact-form"
          onSubmit={handleSubmit}
          noValidate
        >
          <div>
            <p className="info-page__eyebrow">{content.realEstatePage.formEyebrow}</p>
            <h2>{content.realEstatePage.formTitle}</h2>
          </div>
          <label>
            Name
            <input name="name" type="text" autoComplete="name" required />
          </label>
          <label>
            Real Estate type
            <select name="realEstateType" required defaultValue="">
              <option value="" disabled>Select type</option>
              <option value="Cafe">Cafe</option>
              <option value="Restaurant">Restaurant</option>
              <option value="Retail mart">Retail mart</option>
            </select>
          </label>
          <label>
            Contact number
            <input
              name="contactNumber"
              type="tel"
              inputMode="tel"
              autoComplete="tel"
              pattern={phonePattern}
              placeholder="+91 98765 43210"
              title="Enter a valid 10 digit Indian mobile number."
              aria-invalid={Boolean(phoneError)}
              aria-describedby={phoneError ? 'real-estate-phone-error' : undefined}
              onChange={(event) => setPhoneError(getIndianMobileError(event.currentTarget.value))}
              required
            />
            {phoneError ? <span className="field-error" id="real-estate-phone-error">{phoneError}</span> : null}
          </label>
          <label>
            Message
            <textarea name="message" rows={5} required />
          </label>
          <button type="submit" disabled={formStatus === 'submitting'}>
            {formStatus === 'submitting' ? 'Sending...' : 'Send enquiry'}
          </button>
          {formMessage ? <p className={`form-message form-message--${formStatus}`}>{formMessage}</p> : null}
        </form>
      </section>
    </main>
  )
}

export default RealEstatePage
